import * as yup from 'yup';

interface LoginSchemaProps {
  email: {
    format: string;
    required: string;
  };
  password: {
    required: string;
  };
}

interface LoginFormSchema {
  email?: string;
  password?: string;
}

const loginSchema = (
  validationSchema: LoginSchemaProps
): yup.SchemaOf<LoginFormSchema> => {
  const { email, password } = validationSchema;

  return yup.object({
    email: yup.string().email(email.format).required(email.required),
    password: yup.string().required(password.required),
  });
};

export default loginSchema;
